var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwapVert1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_510",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_510)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.75 11V4.875L4.5625 7.0625L3.5 6L7.5 2L11.5 6L10.4375 7.0625L8.25 4.875V11H6.75ZM12.5 18L8.5 14L9.5625 12.9375L11.75 15.125V9H13.25V15.125L15.4375 12.9375L16.5 14L12.5 18Z",
    fill: "#D0D4DE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwapVert1);
export default __webpack_public_path__ + "static/media/swap-vert1.22c5b268a39cbcf912e5e3be3cd61d8e.svg";
export { ForwardRef as ReactComponent };